import React from "react";
import { createSvgIcon } from "@mui/material";

export const InfoIcon = createSvgIcon(
  <path d="M 11 7 L 13 7 L 13 9 L 11 9 L 11 7 Z M 11 11 L 13 11 L 13 17 L 11 17 L 11 11 Z"></path>,
  "Info"
);
